// Shared password strength meter, used by both account creation and the
// password-change form in Settings, so new accounts get the same guidance
// (and a real minimum) that changing your password already enforces.
export function getStrengthLevel(password, t = (k) => k) {
  if (!password) return { score: 0, width: '0%', color: '#2A3870', label: t('strengthEnterPassword') };

  let score = 0;
  if (password.length >= 8) score += 1;
  if (/[A-Z]/.test(password)) score += 1;
  if (/[0-9]/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password)) score += 1;

  const levels = [
    { width: '25%', color: '#E05555', label: t('strengthWeak') },
    { width: '50%', color: '#F5A623', label: t('strengthMedium') },
    { width: '75%', color: '#F5C400', label: t('strengthGood') },
    { width: '100%', color: '#3A9E4F', label: t('strengthStrong') },
  ];

  return { score, ...levels[Math.min(score, 3)] };
}

// Minimum bar for a new account: at least 8 characters and at least one
// number - Firebase's own floor is just 6 characters with no other rules.
export function isPasswordStrongEnough(password) {
  return Boolean(password) && password.length >= 8 && /[0-9]/.test(password);
}
